import { createNamespacedHelpers } from 'vuex';
const detectorMapper = createNamespacedHelpers('detector')
const imageMapper = createNamespacedHelpers('trainer/image');

const GOOD_CLASS = '0';
const SLIDE_INTERVAL = 3000;
export default {
	name: 'ImagesListModal',
	data() {
		return {
			GOOD_CLASS: GOOD_CLASS,
			myInterval: null,
			slideShow: 0,
			slideInterval: SLIDE_INTERVAL
		};
	},

	props: {
		images: {
			type: Object,
			default: () => {
				return {
					imagesList: [],
					from: '',
				};
			},
		},
		modalId: {
			type: String,
		},
		slide: {
			type: Number,
		},
		hasBorder: {
			type: Boolean,
		},
		hasTag: {
			type: Boolean,
		},
	},

	computed: {
		...imageMapper.mapGetters(['reversedImages']),
		
		slideCount: {
			get() {
				return this.slide;
			},
			set(val) {
				this.$emit('update:slide', val);
			},
		},
		newImagesList() {
			return this.images.imagesList.map((image) => {
				return {
					...image,
					hasBorder: this.hasBorder,
					hasTag: this.hasTag,
				};
			});
		},

		imagePreviewVisible: {
			get() {
				return this.$store.state.detector.imagePreviewVisible
			},
			set(value) {
				console.log(value);
				this.$store.dispatch('detector/showImagePreviewModal', value)
			}
		},

		newImagesListLength() {
			return this.newImagesList.length;
		},

		autoSlide: {
			get() {
				return this.$store.state.detector.autoSlide;
			},
			set() {
				this.$store.dispatch('detector/switchAutoSlide')
			}
		}
	},

	methods: {
		...detectorMapper.mapActions(['hideImagePreviewModal']),

		openModal() {
			this.$bvModal.show('carousel-modal');
		},

		onShown() {
			this.insertCustomElement();
		},

		onCloseModal() {
			this.hideImagePreviewModal();
		},

		insertCustomElement() {
			this.myInterval = setInterval(() => {
				const carousels = document.getElementsByClassName('carouselImageWrapper');
				console.log({ carousels: carousels });
				if (carousels.length > 0) {
					clearInterval(this.myInterval);
					// Lặp qua các phần tử image trong newImagesList
					this.newImagesList.forEach((image, idx) => {
						let template = `<div class="${
							!image.hasTag
								? ''
								: image.class === GOOD_CLASS
								? 'carouselImage--detected--goodTag'
								: 'carouselImage--detected--badTag'
						}"
                  >
                    ${
											!image.hasTag
												? ''
												: `<h3>
                      ${image.class === GOOD_CLASS ? 'OK' : 'NG'}
                      </h3>`
										}
                </div>`;

						carousels[idx].insertAdjacentHTML('beforeend', template);
					});
				}
			}, 10);
		},
		
		closeModal() {
			this.$bvModal.hide(this.modalId);
		},
	},

	mounted() { },
	
	watch: {
		autoSlide: function (val) {
			if (val === true) {
				this.slideShow = this.slideInterval;
			}
			else this.slideShow = 0
		}
	}
};
